import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {Navigate} from 'react-router-dom'

const PrivateRoute = (props) => {
    useEffect(() => {
        window.scroll(0,0)
    })
    const { login, fetchUser, fail, query, children } = props

    // Si l'utilisateur n'est pas connecté et le fetch a échoué, rediriger vers login
    if (fail && !login) {
        return <Navigate to={'/connexion'} />
    }

    // Si pas encore connecté, tenter de fetch l'utilisateur (le cookie HttpOnly sera envoyé automatiquement)
    if (!login) {
        return fetchUser({query})
    }

    return children
}

PrivateRoute.propTypes = {
    component: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
}

export default PrivateRoute
